<app-activity-card
  [title]="subscription?.activity?.name"
  [address]="subscription?.activity?.fullAddress"
  [duration]="subscription?.activity?.formattedDuration(dateLocale)"
  [picture]="picture"
  [price]="subscription?.totalPrice"
  [currency]="subscription?.item?.currency"
  [isLive]="subscription?.activity?.isLive"
  [isOpened]="isOpened"
  [type]="type"
  class="booking-detail"
>
  <div top-text #topText class="text-green-dark-1">
    <time
      [attr.datetime]="
        subscription?.timeslot?.startDate | localizedDate: 'y-MM-dd'
      "
      >{{ subscription?.timeslot?.startDate | localizedDate: 'EEE dd MMM' }}
    </time>
    <time
      [attr.datetime]="
        subscription?.timeslot?.startDate | localizedDate: 'HH:mm'
      "
    >
      {{ 'timeslot.start_at' | translate }}
      {{ subscription?.timeslot?.startDate | localizedDate: 'HH:mm' }}
      <span
        *ngIf="
          isTimezoneSelectionEnabled && isLive(subscription?.activity?.type)
        "
      >
        {{ subscription?.timeslot?.startDate | localizedDate: '(z)' }}
      </span>
    </time>
  </div>

  <div drop-down #dropDown>
    <ng-container *ngIf="displayLiveConnectionDetails">
      <app-divider></app-divider>

      <section>
        <h2 class="booking-detail__title">
          {{ 'attendee.bookings.live.title' | translate }}
        </h2>

        <div class="booking-detail__wrapper">
          <p class="booking-detail__label">
            {{ 'attendee.bookings.live.link.label' | translate }}
          </p>

          <p class="booking-detail__value">
            {{ liveEventUrlToDisplay }}
          </p>
          <a
            *ngIf="hasLiveButtons && hasLiveLink"
            app-vtmn-play-button
            target="_blank"
            [href]="liveEventUrlToDisplay"
            [size]="vtmnPlayButtonSize.SMALL"
            [rel]="'noreferrer'"
          >
            {{ 'attendee.bookings.live.redirection.link' | translate }}
          </a>
        </div>

        <div class="booking-detail__wrapper">
          <p class="booking-detail__label">
            {{ 'attendee.bookings.live.password' | translate }}
          </p>

          <p class="booking-detail__value">
            {{ liveEventNoteForAttendees }}
          </p>

          <button
            *ngIf="hasLiveButtons && hasNoteForAttendees"
            app-vtmn-play-button
            type="button"
            [type]="ctaButtonType.Button"
            [size]="vtmnPlayButtonSize.SMALL"
            (click)="copyText()"
          >
            {{ 'attendee.bookings.live.copy.link' | translate }}
          </button>
        </div>
      </section>
    </ng-container>

    <app-divider></app-divider>

    <section>
      <h2 class="booking-detail__title">
        {{ 'booking.offer.detail' | translate }}
      </h2>

      <app-attendee-booking-offers [subscription]="subscription">
      </app-attendee-booking-offers>
    </section>

    <app-divider></app-divider>

    <section class="booking-detail__cta-wrapper">
      <button
        *ngIf="isMobileDevice && subscription.activity.isEvent && bookingItemId"
        class="booking-detail__cta cta"
        (click)="downloadWalletPass(bookingItemId)"
      >
        <vtmn-play-icon class="cta__icon" [name]="icon.Wallet"></vtmn-play-icon>

        <span class="cta__text">{{ 'booking.offer.wallet' | translate }}</span>

        <vtmn-play-icon
          class="cta__arrow-icon"
          [name]="icon?.ChevronRight"
        ></vtmn-play-icon>
      </button>

      <a
        *ngIf="codeSubscription"
        class="booking-detail__cta cta"
        target="_blank"
        [rel]="'noopener noreferrer'"
        [href]="url"
        download
      >
        <vtmn-play-icon class="cta__icon" [name]="codeIcon"></vtmn-play-icon>

        <span class="cta__text">
          {{ qrCodeTranslation }}
        </span>

        <vtmn-play-icon
          class="cta__arrow-icon"
          [name]="icon?.ChevronRight"
        ></vtmn-play-icon>
      </a>

      <a
        *ngIf="isReviewable"
        class="booking-detail__cta cta"
        [href]="reviewPageUrl"
        target="_blank"
        rel="noreferrer"
      >
        <vtmn-play-icon class="cta__icon" [name]="icon?.Star"></vtmn-play-icon>

        <span class="cta__text">
          {{ 'bookings-list.activity.review' | translate }}
        </span>

        <vtmn-play-icon
          class="cta__arrow-icon"
          [name]="icon?.ChevronRight"
        ></vtmn-play-icon>
      </a>

      <button
        *ngIf="haveOrganization"
        class="booking-detail__cta cta"
        (click)="storeMessagingData()"
        type="button"
      >
        <vtmn-play-icon
          class="cta__icon"
          [name]="icon?.Message"
        ></vtmn-play-icon>
        <span class="cta__text">
          {{ 'bookings-list.activity.contact_organizer' | translate }}
        </span>
        <vtmn-play-icon
          class="cta__arrow-icon"
          [name]="icon?.ChevronRight"
        ></vtmn-play-icon>
      </button>

      <a
        *ngIf="subscription?.activity?.sku"
        [routerLink]="[path, subscription?.activity?.sku] | localize"
        class="booking-detail__cta cta"
        [attr.aria-label]="subscription?.activity?.name"
      >
        <vtmn-play-icon class="cta__icon" [name]="icon?.Eye"></vtmn-play-icon>
        <p class="cta__text">
          {{ 'bookings-list.activity.show' | translate }}
        </p>

        <vtmn-play-icon
          class="cta__arrow-icon"
          [name]="icon?.ChevronRight"
        ></vtmn-play-icon>
      </a>

      <a
        *ngIf="subscription?.totalPrice > 0"
        class="booking-detail__cta cta"
        [href]="invoiceUrl"
      >
        <vtmn-play-icon class="cta__icon" [name]="icon.File"></vtmn-play-icon>
        <p class="cta__text">
          {{ 'bookings-list.activity.download' | translate }}
        </p>
        <vtmn-play-icon
          class="cta__arrow-icon"
          [name]="icon.ChevronRight"
        ></vtmn-play-icon>
      </a>

      <ng-container *ngIf="refundEnabled">
        <button
          type="button"
          class="booking-detail__cta cta"
          (click)="refundModal.show()"
        >
          <vtmn-play-icon
            class="cta__icon"
            [name]="icon?.CloseCircle"
          ></vtmn-play-icon>

          <p class="cta__text">
            {{ 'bookings-list.refund' | translate }}
          </p>

          <vtmn-play-icon
            class="cta__arrow-icon"
            [name]="icon?.ChevronRight"
          ></vtmn-play-icon>
        </button>

        <app-modal #refundModal class="modal" (modalClose)="refundModal.hide()">
          <span modal-header class="modal__title title-5">
            {{ 'bookings-list.modal.refund.title' | translate }}
          </span>

          <div modal-content>
            <p *ngIf="canRefund">
              {{ 'bookings-list.modal.refund.message' | translate }}
            </p>

            <p *ngIf="!canRefund">
              {{ noRefundMessage }}
            </p>

            <div class="modal__footer">
              <button
                app-vtmn-play-button
                type="button"
                loading
                [variant]="vtmnPlayButtonVariant.SECONDARY"
                [shape]="vtmnPlayButtonShape.SQUARED"
                (click)="refundModal.hide()"
              >
                {{ 'bookings-list.modal.refund.abort' | translate }}
              </button>

              <button
                app-vtmn-play-button
                type="button"
                [variant]="vtmnPlayButtonVariant.NEGATIVE"
                [shape]="vtmnPlayButtonShape.SQUARED"
                (click)="refund()"
                [disabled]="isLoading ? true : null"
                [attr.data-disabled]="isLoading ? true : null"
              >
                {{ 'bookings-list.modal.refund.confirm' | translate }}
              </button>
            </div>
          </div>
        </app-modal>

        <app-modal
          #confirmedModal
          class="modal"
          (modalClose)="hideConfirmationModal()"
        >
          <div modal-header>
            <span class="modal__title title-5">
              {{ 'bookings-list.modal.confirmed.title' | translate }}
            </span>
          </div>

          <div modal-content>
            <p>{{ 'bookings-list.modal.confirmed.message' | translate }}</p>
          </div>
        </app-modal>
      </ng-container>
    </section>
  </div>
</app-activity-card>
